function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M275.372 3.95126C273.029 1.48343 269.816 0.00195312 266.487 0.00195312H67.1461C30.3625 0.00195312 0 30.2436 0 67.0233V443.978C0 480.761 30.3625 511.003 67.1461 511.003H337.703C374.487 511.003 404.849 480.761 404.849 443.978V144.661C404.849 141.452 403.368 138.368 401.27 136.021L275.372 3.95126ZM278.951 43.573L363.255 132.072H308.452C292.159 132.072 278.951 118.988 278.951 102.696V43.573ZM337.703 486.317H67.1461C44.0662 486.317 24.6861 467.186 24.6861 443.978V67.0233C24.6861 43.9434 43.9414 24.6881 67.1461 24.6881H254.265V102.696C254.265 132.688 278.46 156.758 308.452 156.758H380.163V443.978C380.163 467.186 360.908 486.317 337.703 486.317Z",
  fill: "#C4C4C4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.414 356.839C195.761 359.307 198.969 360.789 202.424 360.789C205.882 360.789 209.09 359.307 211.433 356.839L283.765 279.202C288.455 274.263 288.084 266.364 283.149 261.799C278.209 257.109 270.31 257.475 265.745 262.415L214.767 317.093V182.31C214.767 175.518 209.211 169.967 202.424 169.967C195.636 169.967 190.081 175.518 190.081 182.31V317.093L139.227 262.415C134.537 257.479 126.759 257.109 121.823 261.799C116.888 266.489 116.517 274.267 121.207 279.202L193.414 356.839Z",
  fill: "#C4C4C4"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.161 412.307C88.1238 411.876 88.1049 411.44 88.1049 411V384.5C88.1049 377.596 93.7013 372 100.605 372C107.508 372 113.105 377.596 113.105 384.5V401H292.105V384.5C292.105 377.596 297.701 372 304.605 372C311.508 372 317.105 377.596 317.105 384.5V411C317.105 413.82 316.327 416.457 314.974 418.711C313.014 423.003 308.715 426 303.761 426H302.105H292.105H113.105H103.105H100.449C93.661 426 88.1049 420.374 88.1049 413.5C88.1049 413.098 88.1239 412.7 88.161 412.307Z",
  fill: "#C4C4C4"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 405,
    height: 512,
    viewBox: "0 0 405 512",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.f0981e4b.svg";
export { ForwardRef as ReactComponent };